import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Unidade } from '../../../models/unidade';
import 'rxjs/add/observable/combineLatest';
import { Observable } from 'rxjs/Observable';
import { ConfirmationService } from 'primeng/primeng';
import { Prestador } from '../../../models/prestador';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { FaseService } from '../../fase/fase.service';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { UnidadeService } from '../../shared/services/unidade.service';
import { EditalCredenciamentoService } from '../edital-credenciamento.service';
import { Util } from '../../shared/util';

@Component({
  templateUrl: './edital-credenciamento-form.component.html',
})
export class EditalCredenciamentoFormComponent extends WebPage implements OnInit {

  fases;
  unidades;
  idEditalCredenciamento;
  prestadores;

  get arquivos() { return this.form.get('arquivos') as FormArray; }
  get idPrestador() { return this.form.get('idPrestador'); }
  get isDistribuicaoEquitativa() { return this.form.get('isDistribuicaoEquitativa'); }
  get descricaoEdital() { return this.form.get('descricaoEdital'); }
  get idFase() { return this.form.get('idFase'); }
  get isVigente() { return this.form.get('isVigente'); }

  uploadUrl: string;
  arquivosToRemove = new FormArray([]);

  form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router, private route: ActivatedRoute,
    private confirmationService: ConfirmationService, messageService: MessageService,
    private faseService: FaseService,
    private arquivoService: ArquivoService,
    private unidadeService: UnidadeService,
    private editalCredenciamentoService: EditalCredenciamentoService
  ) {
    super(messageService);

    this.form = this.fb.group({
      idEditalCredenciamento: [],
      idFase: [null, Validators.required],
      idUnidade: [null, Validators.required],
      idPrestador: [null, Validators.required],
      isVigente: [null, Validators.required],
      isDistribuicaoEquitativa: [null],
      descricaoEdital: [null, Validators.required],
      arquivos: new FormArray([])
    });

    this.uploadUrl = this.arquivoService.uploadUrl + 'editalCredenciamento';

    this.route.paramMap.subscribe(params => {
      if (params.has('idEditalCredenciamento')) {
        this.idEditalCredenciamento = params.get('idEditalCredenciamento');
      }
    });
  }

  ngOnInit() {
    this.isLoading = true;
    this.faseService.getAllFull()
      .finally(() => this.isLoading = false)
      .subscribe(
        fases => this.fases = fases,
        error => this.gerenciaErro(error)
      );

    this.isLoading = true;
    this.editalCredenciamentoService.getPrestadores()
      .finally(() => this.isLoading = false)
      .subscribe(
        prestadores => this.prestadores = prestadores,
        error => this.gerenciaErro(error)
      );

      if (!Util.isNullOrEmptyOrUndefined(this.idEditalCredenciamento)) {
        this.isLoading = true;
        this.editalCredenciamentoService.getFull(this.idEditalCredenciamento)
          .finally(() => this.isLoading = false)
          .subscribe(
            edital => {
              this.form.patchValue({
                idEditalCredenciamento: edital.idEditalCredenciamento,
                idFase: edital.idFase,
                idUnidade: edital.idUnidade,
                idPrestador: edital.idPrestador,
                isVigente: edital.isVigente,
                isDistribuicaoEquitativa: edital.isDistribuicaoEquitativa,
                descricaoEdital: edital.descricaoEdital,
              });

              edital.arquivosMeio.forEach(arquivoMeio => {
                const arquivo = arquivoMeio.arquivo;
                this.adicionaArquivo(arquivo.idArquivo, arquivo.nome, true);
              });
            },
            error => this.gerenciaErro(error)
          );
      }
  }

  carregarUnidades() {
    this.isLoading = true;
    this.unidadeService.getUnidadesParticipantesByFase(this.idFase.value)
      .finally(() => this.isLoading = false)
      .subscribe(
        unidades => this.unidades = unidades,
        error => this.gerenciaErro(error)
      );
  }

  prestadorChanged() {
    this.descricaoEdital.setValidators(Validators.required);
    if (this.idPrestador.value === Prestador.idClinica) {
      this.isDistribuicaoEquitativa.setValidators(Validators.required);
    } else {
      this.form.patchValue({ isDistribuicaoEquitativa: null });
      this.isDistribuicaoEquitativa.clearValidators();
    }

    this.descricaoEdital.updateValueAndValidity();
    this.isDistribuicaoEquitativa.updateValueAndValidity();
  }

  distribuicaoClicked(option: boolean) {
    if (option) {
      this.descricaoEdital.clearValidators();
      this.form.patchValue({ descricaoEdital: null });
    } else {
      this.descricaoEdital.setValidators(Validators.required);
    }

    this.descricaoEdital.updateValueAndValidity();
  }

  // ------
  // Arquivos
  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean) {
    this.isLoading = false;

    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo,
      isOld: isOld
    });
    this.arquivos.push(arquivoFormGroup);
  }

  removeArquivo(arquivo: AbstractControl) {
    this.arquivosToRemove.push(arquivo);

    const index = this.arquivos.controls.indexOf(arquivo);
    this.arquivos.removeAt(index);
  }

  removeArquivosDoBanco(arquivos: AbstractControl[]) {
    const combined = arquivos.map(a => this.arquivoService.removeArquivo(a.value.idArquivo));
    this.isLoading = true;
    Observable.combineLatest(combined)
      .finally(() => this.isLoading = false)
      .subscribe(
        () => {},
        error => this.gerenciaErro(error)
      );
  }
  // Arquivo
  // ------

  submit() {
    if (!this.validaForm()) {
      return;
    }

    this.confirmationService.confirm({
      message: 'Deseja confirmar os dados digitados?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.removeArquivosDoBanco(this.arquivosToRemove.controls);

        this.isLoading = true;
        this.editalCredenciamentoService.cadastrarEditarEdital(this.form.value)
          .finally(() => this.isLoading = false)
          .subscribe(
            () => {
              localStorage.setItem('mensagem', 'Registro salvo com sucesso!');
              this.router.navigate(['/gerenciar-edital-credenciamento']);
            },
            error => this.gerenciaErro(error)
          );
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        const arquivosNovos = this.arquivos.controls.filter(arquivo => !arquivo.value.isOld);
        arquivosNovos.concat(this.arquivosToRemove.controls.filter(arquivo => !arquivo.value.isOld));
        this.removeArquivosDoBanco(arquivosNovos);

        this.router.navigate(['/gerenciar-edital-credenciamento']);
      }
    });
  }

  validaForm(): boolean {
    if (this.idPrestador.value === Prestador.idCfc || !this.isDistribuicaoEquitativa.value) {
      if (this.arquivos.length === 0) {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Documento não inserido!' });
        return false;
      }

      if (this.arquivos.length !== 1) {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'É necessário carregar apenas 1 arquivo!' });
        return false;
      }
    }

    if (this.form.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Formulário preenchido incorretamente.' });
      return false;
    }

    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/editalCredenciamento/edital-credenciamento-form/edital-credenciamento-form.component.ts